import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class FumbleSnapFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return [
            FootballState.FumbledSnapRecovered,
            FootballState.FumbledSnapLost
        ].some((s) => s === fragment.associatedState);
    }

    getRawFragment(play, serializationContext, fumbleRecovery) {
        const { fieldPosition: initialPosition } = play.contextSnapshot;
        let rawPlay = "";
        if (fumbleRecovery?.recoveredBy) {
            const fumble = play.getPreceedingFragment(fumbleRecovery, [
                FootballState.FumbledSnap
            ]);

            const formattedInitialPosition = this.resolveFormattedFieldPosition(
                serializationContext,
                initialPosition
            );
            const fumbledByUniform = this.resolveUniform(
                serializationContext,
                fumble.fumbledBy
            );

            const recoveringUniform = this.resolveUniform(
                serializationContext,
                fumbleRecovery.recoveredBy
            );

            let values = [
                this.resolveTeam(
                    serializationContext,
                    fumbleRecovery.recoveredBy
                ),
                this.resolveFormattedFieldPosition(
                    serializationContext,
                    fumbleRecovery.recoveredAt
                ),
                recoveringUniform
            ];

            // TODO: Replace or remove RUSH when CMS can support Fumbled Snap fragments.
            let rushValues = [fumbledByUniform, formattedInitialPosition];
            rawPlay = `RUSH:${rushValues.join()} FORCE:undefined FUMB:${values.join()}`;
        }

        return rawPlay;
    }
}
